import { ChevronsRight } from 'lucide-react'
import { DrawerClose, DrawerDescription, DrawerHeader, DrawerTitle } from '@/shadcn/ui/drawer'
import { Skeleton } from '@/ui/atoms/skeleton/Skeleton'

export function SideDrawerSkeleton() {
  return (
    <>
      <DrawerHeader className="gap-0 text-left">
        <div>
          <div className="flex items-center justify-between">
            <DrawerClose className="transition-colors hover:text-primary">
              <ChevronsRight className="h-4 w-4" />
            </DrawerClose>

            <Skeleton className="h-12 w-36" />
          </div>
        </div>
        <DrawerTitle className="mt-3 pl-1" asChild>
          <Skeleton className="h-12 w-44" />
        </DrawerTitle>

        <DrawerDescription className="mt-2 pb-6 pl-1">
          <Skeleton className="h-4 w-36" />
        </DrawerDescription>

        <div className="flex gap-3">
          <Skeleton className="h-12 flex-1" />
          <Skeleton className="h-12 flex-1" />
        </div>

        <div className="flex gap-3 pt-7 pl-1">
          <Skeleton className="h-8 w-24" />
          <Skeleton className="h-8 w-24" />
          <Skeleton className="h-8 w-24" />
        </div>
      </DrawerHeader>

      <div className="p-4 pl-10">
        {Array.from({ length: 5 }).map((_, index) => (
          <div className="flex items-center justify-between py-3" key={index}>
            <div className="flex items-center gap-3">
              <Skeleton className="h-10 w-10 rounded-full" />
              <Skeleton className="h-12 w-36" />
            </div>

            <div className="flex items-center gap-3">
              <Skeleton className="h-4 w-24" />
            </div>
          </div>
        ))}
      </div>
    </>
  )
}
